
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class TimeSinceLastVisit extends Vue {

  headerTranslations: Record<string, string> = {
    TimeCategory: "Kategorie Zeit",
    PatientCount: "Patientenanzahl",
    PatientPercentage: "Prozentsatz der Patienten"
  };
  // Use new getter with key-based data
  get chartData(): any[] {
    return dataVisualizationModule.getChartData("timeSinceLastVisit");
  }

  get tableHeaders(): string[] {
    return this.chartData.length ? Object.keys(this.chartData[0]) : [];
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("timeSinceLastVisit");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
